export default "__VITE_ASSET__AroVE6KC__"